import React, { useState } from 'react';
import {
    Alert, Card, CardContent, CircularProgress, MenuItem, Stack, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, TextField, Typography,
} from '@mui/material';
import {
    DRUHY, DruhOdpojeni, NAZEV_DRUHU, delkaVypadku, formatCas, stavUpozorneni,
} from '../../api/JsdhNotifikaceService/service/OdpojeniService';
import { useOdpojeniVypadkyQuery } from '../../api/JsdhNotifikaceService/service/OdpojeniMutations';

/** Poslední výpadky (spec oddíl 7): posledních 50, filtr druhu. Bez MODUL_IOT jen kiosek. */
const VypadkyTabulka: React.FC<{ iot: boolean }> = ({ iot }) => {
    const [druh, setDruh] = useState<DruhOdpojeni | ''>('');
    // Bez MODUL_IOT se ptáme rovnou na kiosek, aby "posledních 50" byly opravdu výpadky kiosku.
    const efektivni = iot ? druh : 'KIOSEK';
    const { data, isLoading, error } = useOdpojeniVypadkyQuery(efektivni);
    const druhy = iot ? DRUHY : (['KIOSEK'] as DruhOdpojeni[]);
    const radky = data ?? [];

    return (
        <Card variant="outlined" sx={{ mt: 3 }}>
            <CardContent>
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ mb: 2 }}>
                    <Typography variant="h6" component="h2">Poslední výpadky</Typography>
                    <TextField
                        select
                        size="small"
                        label="Druh"
                        value={efektivni}
                        onChange={(e) => setDruh(e.target.value as DruhOdpojeni | '')}
                        sx={{ minWidth: 180 }}
                    >
                        {iot && <MenuItem value="">Všechny</MenuItem>}
                        {druhy.map((d) => <MenuItem key={d} value={d}>{NAZEV_DRUHU[d]}</MenuItem>)}
                    </TextField>
                </Stack>
                {isLoading && <CircularProgress size={24} />}
                {error && <Alert severity="error">Výpadky se nepodařilo načíst.</Alert>}
                {!isLoading && !error && radky.length === 0 && (
                    <Typography color="text.secondary">Zatím žádné výpadky.</Typography>
                )}
                {radky.length > 0 && (
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Zařízení</TableCell>
                                    <TableCell>Druh</TableCell>
                                    <TableCell>Od</TableCell>
                                    <TableCell>Do</TableCell>
                                    <TableCell>Délka</TableCell>
                                    <TableCell>Upozornění</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {radky.map((v) => (
                                    <TableRow key={v.id}>
                                        <TableCell>
                                            {v.nazev || v.zarizeniKlic}
                                            {v.pricina === 'NEUKAZUJE_APLIKACI' && (
                                                <Typography variant="caption" color="text.secondary" display="block">
                                                    neukazuje aplikaci
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell>{NAZEV_DRUHU[v.druh]}</TableCell>
                                        <TableCell>{formatCas(v.offlineOd)}</TableCell>
                                        <TableCell>{v.obnoveno ? formatCas(v.obnoveno) : 'trvá'}</TableCell>
                                        <TableCell>{delkaVypadku(v.offlineOd, v.obnoveno)}</TableCell>
                                        <TableCell>{stavUpozorneni(v)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </CardContent>
        </Card>
    );
};

export default VypadkyTabulka;
